import React from 'react';
import { useTranslation } from 'react-i18next';

import { AllowanceDiscrepancy } from 'services/invoiceDiscrepancies/types';
import { formatCurrency } from 'support/helpers/currency/currency';

type AllowanceDiscrepancyViewProps = {
  data: AllowanceDiscrepancy['data'];
  currency: AllowanceDiscrepancy['currency'];
};

export const AllowanceDiscrepancyView: React.FC<AllowanceDiscrepancyViewProps> = ({ data, currency }) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-4">
      <p className="text-gray-700">
        {t('invoiceVerification:detailsPage.discrepanciesModal.content.allowanceDescription', {
          value: formatCurrency(data.actual?.amount ?? 0, currency),
        })}
      </p>
    </div>
  );
};
